module.exports = angular.module(__filename, []).service('audienceMgmt', ['mgmtServiceFactory', function(mgmtServiceFactory) {
  const service = mgmtServiceFactory.createService('audience');

  return {
    list: audienceList,
    create: service.create,
    update: service.update,
    delete: deleteAudience,
    activateUnified
  };

  // Filter audience by channel
  async function audienceList(channel) {
    const data = await service.list();
    return channel
      ? data.filter(audience => (audience.channel === channel) || (channel === 'articles' && !audience.channel))
      : data;
  }

  function deleteAudience(audienceId, isAudienceActivated = false) {
    return service.customRequest('DELETE', `/${audienceId}/${isAudienceActivated}`);
  }

  // PHOB-1857: activate a unified TV parent segment. Splits into per-source child audiences and
  // dispatches them (see abi-mgmt activate_unified contract). p_id is filled by the service's
  // currentProgram(); Authorization is attached globally; SSO-Access-Token is passed per-call.
  function activateUnified(segmentId, body, ssoAccessToken) {
    return service.customRequest(
      'POST',
      `/${segmentId}/activate_unified`,
      body,
      { 'SSO-Access-Token': ssoAccessToken },
      { skipNotification: true }
    );
  }
}]);